<template>
  <div>
    <v-tooltip top>
      <template v-slot:activator={on}>
        <v-speed-dial v-model="fab" :direction="direction">
          <template v-slot:activator>
            <v-btn v-model="fab"
                   v-on="on"
                   id="botaoImprimir"
                   :outlined="outlined"
                   :disabled="disabled"
                   :color="color"
                   icon>
              <v-icon v-if="fab">
                mdi-close
              </v-icon>
              <v-icon v-else>
                mdi-file-document
              </v-icon>
            </v-btn>
          </template>
          <v-tooltip top>
            <template v-slot:activator={on}>
              <v-btn v-on="on" fab small :color="color" @click="$emit('gerarRelatorio')">
                <v-icon>print</v-icon>
              </v-btn>
            </template>
            Imprimir relatório
          </v-tooltip>
          <v-tooltip top>
            <template v-slot:activator={on}>
              <v-btn v-on="on" fab small :color="color" @click="$emit('baixarRelatorio')">
                <v-icon>mdi-download</v-icon>
              </v-btn>
            </template>
            Baixar .PDF
          </v-tooltip>
        </v-speed-dial>
      </template>
      {{ texto }}
    </v-tooltip>
  </div>
</template>

<script>
export default {
    name: 'BotaoImprimir',
    props: {
        disabled: {
            type: Boolean,
            default: false
        },
        outlined: {
            type: Boolean,
            default: false
        },
        color: {
            type: String,
            default: 'white'
        },
        texto: {
            type: String,
            default: 'Gerar Relatório'
        },
        direction: {
            type: String,
            default: 'left'
        }
    },
    data() {
        return {
            fab: false
        }
    }
}
</script>

<style scoped lang="stylus">

</style>
